import React, { Component } from 'react';
import { Table, Avatar, Input, Tooltip,Button, Icon, Spin, Card, Select, Radio, Modal, Row, Col, Form } from 'antd';
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { history } from '../../container/History';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import InputMask from 'react-input-mask'
import { withRouter } from "react-router-dom";
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
let EditModeON = false
let Phoneid = 0;
let Emailid = 0;
class MembershipAlumniInfoForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            editmode: false,
            nonus: 2,
            addressID: 0,
            addressTypeID: 0,
            EmailId: '',
            Phones: '',
            emails: '',
            Email: '',
            EmailTypeId: '',
        }
        this.changemode = this.changemode.bind(this)
    }

    handleSubmitUpdateAddress = (e) => {
        let emails = (Array.isArray(this.props.profileinfo.emails) && this.props.profileinfo.emails.length > 0) ? this.props.profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''

        let phones = (Array.isArray(this.props.profileinfo.phones) && this.props.profileinfo.phones.length > 0) ? this.props.profileinfo.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.isEditMode(false)
                values.addressline1 = values.address_line_1;
                values.addressline2 = values.address_line_2;
                values.addressline3 = values.address_line_3;
                values.zipcode = values.zip_code;

                values.email = []
                values.emailkeys = []
                values.primaryEmail = []
                values.emailtype = []
                values.primary = [];
                values.phone = []
                values.phoneTypeID = []
                values.phonecountryID = []

                values.email[0] = values.Scouts_Email
                values.emailkeys[0] = 0;
                values.primaryEmail[0] = emails.id;
                values.emailtype[0] = emails.typeId

                values.phonekeys = [0];
                values.primary[0] = phones.id;
                values.phone[0] = values.Scouts_Phone_Number
                values.phoneTypeID[0] = phones.typeId
                values.phonecountryID[0] = values.Scouts_phonecountryID
                // this.props.actions.updateAddress(this.state.addressID, values, this.state.addressTypeID, this.props.personGUID)

                this.props.actions.updateMyAddress(this.props.personGUID, this.state.addressID, values, values.state, this.state.addressTypeID, true, 'alumni')
                this.props.actions.updateProfilePhone(this.props.personGUID, 0, null, 0, null, values, 'alumni', [], [])
                // this.props.actions.updateEmail(URL, method, updateEmailInfo, by)
            }
        });

    }


    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.short}</option>
                )
            })
        }
    }

    countries = () => {
        if (this.props.countries) {
            let countriesarray = this.props.countries.sort((a,b) => a.name - b.name)
            return countriesarray.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }
    }

    cancelEditMode = () => {
        let personGUID = this.props.personGUID
        this.setState({
            editmode: false
        })
        this.props.isEditMode(false)
        if (personGUID == undefined || personGUID == '' || personGUID == null) {
            const loggedinUser = JSON.parse(localStorage.getItem('user'))
            personGUID = loggedinUser.personGuid;
        }
        this.props.actions.getProfileInfo(personGUID)
    }

    getPhoneCode = () => {
        if (this.props.phonecode) {
            
            let phonecode = this.props.phonecode.sort((a,b) => a.name.localeCompare( b.name))
            return phonecode.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }

    }
    getemailtype = () => {
        if (this.props.communicationtypes) {
            let communicationtypes = this.props.communicationtypes
            return communicationtypes.map((k, index) => {
                // if (k.classificationId == "3") {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
                // }
            })
        }
    }
    changemode = () => {
        this.setState({
            editmode: true
        })
        EditModeON = false
        this.props.isEditMode(true)
        if (this.props.address_updated) {
            // this.props.address_updated = false
        }
    }

    nonus = (e) => {
        this.setState({
            nonus: e.target.value,
        });
    }

    addressInfo = () => {
        if (this.props.address_updating) {
            EditModeON = true
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Updating Address Information..." />
                </Col>
            </Row>
        }
        if (this.props.address_updated && EditModeON) {
            this.setState({
                editmode: false
            })
            EditModeON = false
            //this.props.address_updated = false
        }
        if (this.props.profileloading) {
            return <Row>
                <Col span={24}>
                    <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Address Information..." />
                </Col>
            </Row>
        }
        if (this.props.profileinfo) {
            const { getFieldDecorator } = this.props.form;
            let address = this.props.profileinfo.addresses.length > 0 ?this.props.profileinfo.addresses.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
            let phones = this.props.profileinfo.phones.length > 0 ?this.props.profileinfo.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
            let emails = this.props.profileinfo.emails.length > 0 ?this.props.profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''

            if (this.state.addressID == 0) {
                this.setState({
                    addressID: address ? address.id : 1,
                })
            }
            if (this.state.addressTypeID == 0) {
                this.setState({
                    addressTypeID: address ? address.typeId : 1,
                })
            }
            return (<div>
                <div className='margin-bottom-20'>
                    <i class="fa fa-info-circle SelectedRecord margin-right-5 " >
                    <span style={{fontFamily: 'roboto',fontSize: '12px',fontWeight: 'bold',color: '#000000de',marginLeft: '5px'}}>
                    Please update as needed.
                    </span>
                    </i>
                </div>
                <Form onSubmit={this.handleSubmitUpdateAddress}>
                    <Row gutter={40}>
                        {/* {this.state.editmode && <Col span={24}>
                            <FormItem
                                label="Are you outside the US?"
                                className="horizontal-field"
                            >
                                {getFieldDecorator('from_us', {
                                    rules: [{ required: true, message: 'Select the above Information!' }],
                                })(
                                    <RadioGroup onChange={this.nonus} name="from_us" value={this.state.nonus} >
                                        <Radio value={1}>Yes</Radio>
                                        <Radio value={2}>No</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>} */}
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        Address Line 1&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('address_line_1', {
                                    initialValue: address ? address.address1 : "",
                                    rules: [{ required: true, min: 4, message: 'Enter your Address!' }],
                                })(
                                    <Input placeholder="Address Line 1"
                                        // disabled={!this.state.editmode}
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        onChange={() => { this.changemode() }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        Address Line 2&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('address_line_2', {
                                    initialValue: address ? address.address2 : "",
                                    rules: [{ required: false, message: 'Enter your Address!' }],
                                })(
                                    <Input placeholder="Address Line 2"
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        //  disabled={!this.state.editmode} 
                                        onChange={() => { this.changemode() }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        Address Line 3&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('address_line_3', {
                                    initialValue: address ? address.address3 : "",
                                    rules: [{ required: false, message: 'Enter your Address!' }],
                                })(
                                    <Input placeholder="Address Line 3"
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        //  disabled={!this.state.editmode} 
                                        onChange={() => { this.changemode() }}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        {this.state.nonus == 2 && <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        City&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('city', {
                                    initialValue: address ? address.city : "",
                                    rules: [{ required: true, min: 4, message: 'Enter your City!' }],
                                })(
                                    <Input placeholder="City"
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        //  disabled={!this.state.editmode} 
                                        onChange={() => { this.changemode() }}
                                    />
                                )}
                            </FormItem>
                        </Col>}
                        {this.state.nonus == 2 && <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        State&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('state', {
                                    initialValue: address ? address.stateId : "1",
                                    rules: [{ required: true, message: 'Enter your State!' }],
                                })(
                                    <Select
                                        // disabled={!this.state.editmode}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select a State"
                                        optionFilterProp="children"
                                        onChange={() => { this.changemode() }}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.states()}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>}
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        Country&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('country', {
                                    initialValue: address ? address.countryId : "616",
                                    rules: [{ required: true, message: 'Enter your Country!' }],
                                })(
                                    <Select
                                        // disabled={!this.state.editmode}
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select a Country"
                                        optionFilterProp="children"
                                        onChange={() => { this.changemode() }}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.countries()}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={(
                                    <span>
                                        ZIP Code&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator('zip_code', {
                                    initialValue: address ? address.zipCode : "",
                                    rules: [{ required: true, max: 5, message: 'Enter your ZIP Code!' },
                                    {
                                        pattern: new RegExp("^[0-9]*$"),
                                        message: "ZIP Code must be all numeric!"
                                    }],
                                })(
                                    // <InputMask
                                    //     mask="99999"
                                    // disabled={!this.state.editmode}
                                    //     placeholderChar="_"
                                    //     alwaysShowMask
                                    //     maskChar={null}
                                    //     className="ant-input"
                                    //     render={(ref, props) => (
                                    <Input placeholder="ZIP Code"
                                        maxLength={5}
                                        // disabled={!this.state.editmode}
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        onChange={() => { this.changemode() }}
                                    // style={!this.state.editmode ? {background: '#f5f5f5 '} : ''}
                                    />
                                    //     )}
                                    // />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={(
                                    <span>
                                        Scout's Phone Number&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator("Scouts_Phone_Number", {
                                    initialValue: (phones) ? (phones.countryId == "636") ? (phones ? (phones.areaCode + phones.prefix + phones.lineNumber) : "") : (phones.lineNumber) : "",
                                    rules: [{ required: true, min: 10, max: 10, message: 'Enter your Phone Number' },
                                    { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
                                })(
                                    <Input
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        // disabled={!this.state.editmode}
                                        addonBefore={
                                            getFieldDecorator(`Scouts_phonecountryID`, {
                                                rules: [{ required: true, message: 'Select Phone Country ID' }],
                                                initialValue: phones ? (typeof myVar === 'string' ? phones.countryId : phones.countryId.toString()) : "636",
                                            })(
                                                <Select style={{ width: 95 }}
                                                    onChange={() => { this.changemode() }}
                                                    ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}
                                                >
                                                    {this.getPhoneCode()}
                                                </Select>
                                            )
                                        } placeholder="Phone"
                                        onChange={() => { this.changemode() }}
                                    // onChange = {() => {this.getUpdatedPhoneKey(k)}}
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={(
                                    <span>
                                        Scout's Email&nbsp;
                                        <Tooltip placement="top" title="Editable field">
                                            <Icon type="info-circle-o" />
                                        </Tooltip>
                                    </span>
                                )}
                            >
                                {getFieldDecorator("Scouts_Email", {
                                    initialValue: (emails) ? emails.email : "",
                                    rules: [{ required: true, type: "email", message: 'Enter valid email address!' }]
                                })(
                                    <Input
                                        // className={!this.state.editmode ? "colorBlk" : ""}
                                        // addonBefore={
                                        //     getFieldDecorator(`emailtype`, {
                                        //         rules: [{ required: true, message: 'Select Phone Country ID' }],
                                        //         initialValue: emails ? emails.typeId : "",
                                        //     })(
                                        //         <Select style={{ width: 95 }}>
                                        //             {this.getemailtype()}
                                        //         </Select>
                                        //     )
                                        // } 
                                        placeholder='Email Address'
                                        onChange={() => { this.changemode() }}
                                    // onChange = {() => this.getUpdatedEmailKey(k)}
                                    />
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    {this.state.editmode && <div> <Row type='flex' justify='space-around'>
                        <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                            <Row gutter={48} type='flex' justify='space-around'>
                                <Col xs={22} sm={22} md={12} lg={9} xl={9}>
                                    <FormItem>
                                        <Button className="myprofile-cancel-btn" onClick={this.cancelEditMode}>Cancel</Button>
                                    </FormItem>
                                </Col>
                                <Col xs={22} sm={22} md={12} lg={9} xl={9}>
                                    <FormItem>
                                        <Button className="save-change-btn" htmlType='submit' type="primary">SAVE CHANGE</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </div>
                    }
                </Form>
            </div>
            )
        }

        return <Row>
            <Col span={24}>
                <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Address Information..." />
            </Col>
        </Row>
    }


    componentDidMount = (e) => {
        const loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        // this.props.actions.getProfileInfo(personGUID)
        this.props.actions.getCommunicationTypes()
        this.props.actions.getCountries()
        this.props.actions.getPhoneCountries()
        this.props.actions.getStates()
    }
    componentWillReceiveProps = (nextprops) => {
        if (nextprops.profileinfo) {
            if ((this.props.profileinfo ? this.props.profileinfo.profile.personId : "") !== nextprops.profileinfo.profile.personId) {
                Phoneid = 0;
                Emailid = 0;
                this.setState({ Phones: this.state.Phones = '', emails: this.state.emails = '' });
                // this.renderPhones(nextprops.profileinfo);
                // this.renderEmail(nextprops.profileinfo);
            }
        }
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        return (
            <div className="centered">
                <Row>

                    <Col className="" span={24}>
                        <Card
                            className="centered"
                            title="Address Information"
                        // extra={this.state.editmode == false && <Button onClick={this.changemode} type="primary" shape="round" icon="edit" >Edit Address</Button>}
                        >
                            {this.addressInfo()}
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isadmin: state.isadminreducer.isadmin,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        profileloading: state.profilereducer.loading,
        profileinfo: state.profilereducer.profileinfo,
        countries: state.countriesreducer.countries,
        communicationtypes: state.communcationtypesreducer.types,
        phonecode: state.phonecountrycodereducer.code,
        allstates: state.allstatesreducer.states,
        address_updating: state.updateaddressreducer.loading,
        address_updated: state.updateaddressreducer.status
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

const MembershipAlumniInfo = Form.create()(MembershipAlumniInfoForm);

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(MembershipAlumniInfo);



// WEBPACK FOOTER //
// ./src/components/Inc/MembershipAlumniInfo.js